import React from 'react';
import {Stack, Typography} from '@mui/material';
import {Row, StyledCard} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import type {FiscalDocumentCardTherapiesProps} from './types';
import {convertBRLCurrencyToNumber} from 'presentation/utils/convertBRLCurrencyToNumber';
import {formatNumberToBRLCurrency} from 'presentation/utils/formatNumberToBRLCurrency';

const {state: stateLabel, city: cityLabel} = translations['pt-br'].commons;
const {attachment: attachmentLabel, fiscalDocument} =
	translations['pt-br'].privateFlow.refund.conferencePage;

export const FiscalDocumentCardTherapies = ({
	number,
	value,
	verifierCode,
	state,
	city,
	uploads,
}: FiscalDocumentCardTherapiesProps) => {
	const line1 = [
		{
			title: fiscalDocument.valueLabel,
			value: formatNumberToBRLCurrency(convertBRLCurrencyToNumber(value)),
		},
		verifierCode
			? {
					title: fiscalDocument.verifierCodeLabel,
					value: verifierCode,
				}
			: null,
	].filter(value => value !== null);

	const line2 = [
		state
			? {
					title: stateLabel,
					value: state,
				}
			: null,
		city
			? {
					title: cityLabel,
					value: city,
				}
			: null,
	].filter(value => value !== null);
	return (
		<StyledCard.Container>
			<Typography fontWeight={600} variant="subtitle2" color={'text.secondary'}>
				{fiscalDocument.title}
			</Typography>

			<Row.Simple title={fiscalDocument.numberLabel} value={number} />

			<Row.Compound items={line1} />

			<Row.Compound items={line2} />

			<Stack>
				<Typography color="text.secondary">{attachmentLabel}</Typography>
				{uploads.map((fileName, index) => (
					<Typography key={index} variant="body2">
						{fileName}
					</Typography>
				))}
			</Stack>
		</StyledCard.Container>
	);
};
